import { render, staticRenderFns } from "./DeleteArticlePendingInternal.vue?vue&type=template&id=ac7a5500&scoped=true"
import script from "./DeleteArticlePendingInternal.vue?vue&type=script&lang=js"
export * from "./DeleteArticlePendingInternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac7a5500",
  null
  
)

export default component.exports